"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var transformNext;

exports.default = transformNext = function (observer, nextNext) {
  var nextObserver;
  nextObserver = {};
  if (observer.start) {
    nextObserver.start = function (sub) {
      return observer.start(sub);
    };
  }
  if (observer.error) {
    nextObserver.error = function (err) {
      return observer.error(err);
    };
  }
  if (observer.complete) {
    nextObserver.complete = function () {
      return observer.complete();
    };
  }
  if (observer.next) {
    nextObserver.next = nextNext;
  }
  return nextObserver;
};